const API_KEY = 'PCW6G-T82HN-FYG2K-8KH4X';

export async function findAddress(query: string): Promise<Address[]> {
    if (
        process.env.NODE_ENV !== 'production' ||
        /^staging\./.test(window.location.host) ||
        /\.localhost$/.test(window.location.host)
    ) {
        return [{
            line1: '123 Test Street',
            line2: '',
            city: 'Bristol',
            county: '',
            postcode: 'BS1 1AB',
        }, {
            line1: '456 Test Street',
            line2: 'Bedminster',
            city: 'Bristol',
            county: 'Avon',
            postcode: 'BS1 1AB',
        }, {
            line1: '789 Test Street',
            line2: '',
            city: 'Bristol',
            county: 'City of Bristol',
            postcode: 'BS1 1AB',
        }];
    }

    const url = `https://ws.postcoder.com/pcw/${API_KEY}/address/GB/${encodeURIComponent(query)}?format=json&lines=2&postcodeonly=true`;
    const response = await fetch(url);

    if (!response.ok) {
        const body = await response.text();

        throw new Error(body);
    }

    const data = await response.json() as PostcoderAddressResult[];

    return data.map(result => ({
        line1: result.addressline1,
        line2: result.addressline2 || '',
        city: result.posttown,
        county: result.county,
        postcode: result.postcode,
    }));
}

export function formatAddress(address: Address) {
    const {
        line1,
        line2,
        city,
    } = address;

    return [line1, line2, city]
        .filter(line => line !== '')
        .join(', ');
}

export type Address = {
    line1: string,
    line2: string,
    city: string,
    county: string,
    postcode: string,
};

export type PostcoderAddressResult = {
    addressline1: string,
    addressline2?: string,
    summaryline: string,
    subbuildingname?: string,
    buildingname?: string,
    number: string,
    premise: string,
    street: string,
    posttown: string,
    county: string,
    postcode: string,
};
